import { render } from "./TopSellingItems.vue?vue&type=template&id=08ab29fc&scoped=true&ts=true"
import script from "./TopSellingItems.vue?vue&type=script&lang=ts"
export * from "./TopSellingItems.vue?vue&type=script&lang=ts"

import "./TopSellingItems.vue?vue&type=style&index=0&id=08ab29fc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ab29fc"]])

export default __exports__